import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SendGroupResendInviteModel } from 'src/app/models/api/actor-resend-invite.model';
import { StatusUpdateSendGroupDeadlineDaysModel, StatusUpdateSendGroupDeadlineModel, StatusUpdateSendGroupModel, StatusUpdateSendGroupNameModel } from 'src/app/models/status/status-sendgroup.model';

@Injectable({
    providedIn: 'root'
})

export class StatusSendgroupApiClient {

    private ControllerEndpoint(requestGuid: string) {
        return "/fe-api/status-sendgroup/" + requestGuid;
    }

    constructor(private httpClient: HttpClient) { }

    updateSendGroup(requestGuid: string, updateSendGroupModel: StatusUpdateSendGroupModel) {
        return this.httpClient.post(environment.apiUrl + this.ControllerEndpoint(requestGuid) + "/update", updateSendGroupModel);
    }

    resendSendGroupInvites(forRequestGuid: string, forSendGroupId: string) {
        var body: SendGroupResendInviteModel = {
            requestGuid: forRequestGuid,
            sendGroupGuid: forSendGroupId
        };
        // THIS IS NOT THE GENERIC ACTORS endpoint:
        return this.httpClient.post(environment.apiUrl + this.ControllerEndpoint(forRequestGuid) + "/resend-invite", body);
    }

}


